module.exports = "<div class=\"notification\" ng-show=\"notification.visible\" ng-class=\"notification.classes\">\r\n    {{notification.message}}\r\n\r\n    <i class=\"icon-close_x notification-close\" ng-click=\"closeNotification()\"></i>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/olycommon/notification/notification.directive.html
// module id = 609
// module chunks = 1